import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const useLookups = () => {
  const q = (key, url) => useQuery({ queryKey: [key], queryFn: () => api.get(url).then((r) => r.data), staleTime: 300000 }); // eslint-disable-line react-hooks/rules-of-hooks
  const categories = q("categories", "/categories").data || [];
  const settings = q("settings", "/settings").data || {};
  const users = q("users", "/users").data || [];
  const counterparties = q("counterparties", "/counterparties").data || [];
  const companies = q("companies", "/companies").data || [];
  const catName = (id) => categories.find((c) => c.id === id)?.name || "—";
  const userName = (id) => users.find((u) => u.id === id)?.name || "—";
  const cpName = (id) => counterparties.find((c) => c.id === id)?.name || "—";
  const opts = (arr, v = "value", l = "label") => (arr || []).map((x) => ({ value: x[v], label: x[l] }));
  return { categories, settings, users, counterparties, companies, catName, userName, cpName, opts };
};

export const useProjectQuery = (projectId, key, url, opts = {}) =>
  useQuery({ queryKey: [key, projectId], queryFn: () => api.get(url).then((r) => r.data), enabled: !!projectId, ...opts });

export const useInvalidate = (projectId) => {
  const qc = useQueryClient();
  return (...keys) => {
    keys.forEach((k) => qc.invalidateQueries({ queryKey: [k, projectId] }));
    // ogni modifica propaga a tutte le viste dell'operazione (dashboard, imposte, cash flow, report, scenari, co-investimento, brochure, riepilogo…)
    qc.invalidateQueries({ predicate: (q) => Array.isArray(q.queryKey) && q.queryKey[1] === projectId });
    qc.invalidateQueries({ queryKey: ["portfolio"] });
  };
};
